import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { AnalyzerDish, CreateAnalyzerDishDto } from 'types';

export const createAnalyzerDish = (
  data: CreateAnalyzerDishDto
): Promise<AnalyzerDish> => {
  return axios.post(`/api/dishes/connections`, data);
};

type UseCreateAnalyzerDishOptions = {
  config?: MutationConfig<typeof createAnalyzerDish>;
};

export const useCreateAnalyzerDish = ({
  config,
}: UseCreateAnalyzerDishOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousAnalyzerDishes) {
        queryClient.setQueryData(
          ['analyzerDish'],
          context.previousAnalyzerDishes
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['analyzerDish']);
      queryClient.invalidateQueries(['dishes']);
      queryClient.invalidateQueries(['locations']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: createAnalyzerDish,
  });
};
